<template>
  <div class="lv-state-member-input-list">
    <p 
      v-if="inputList.length"
      class="lv-state-member-input-list-title"
    >
      {{ $t('共{number}筆',{number:inputList.length}) }}
      {{ $t('成員資料匯入') }}：
    </p>
    <ValidationObserver
      ref="memberObserver"
    >
      <div class="member-input-list">
        <LvStateMemberInputItem
          v-for="(member_e,member_k) in inputList"
          :key="member_k"
          :value="member_e"
          :number="member_k + 1"
          @delete="$_onDelete(member_k)"
          @input="$_onInput($event, member_k)"
        />
      </div>
    </ValidationObserver>
    <div
      v-if="inputList.length"
      class="member-input-list-btns"
    >
      <WsButton001 out-line @click="$emit('cancel')">
        {{ $t('取消') }}
      </WsButton001>
      <WsButton001 @click="$_onSubmit()">
        {{ $t('送出') }}
      </WsButton001>
    </div>
  </div>
</template>
<script>
export default {
  name: "LvStateMemberInputList",
  props: {
    inputList: {
      type: Array,
      default() {
        return [];
      },
    },
    value: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  methods: {
    $_onDelete(index) {
      this.inputList.splice(index, 1);
    },
    async $_onSubmit() {
      const isValidate = await this.$refs.memberObserver.validate();
      if (!isValidate) {
        return;
      }
      this.$emit("submit", this.inputList);
    },
    $_onInput($event, index) {
      this.inputList[index] = {
        ...this.inputList[index],
        ...$event,
      }
    }
  },
};
</script>